// HTTP katmanını (api.ts interceptor'ı) React'e köprüleyen küçük pubsub.
// Interceptor React'i bilmez; oturum-bitti/yetkisiz olaylarını buradan yayınlar,
// AuthEventsBinder bileşeni dinleyip yönlendirme yapar.

export type AuthEvent = 'signed-out' | 'forbidden'

// signed-out olayı opsiyonel `reason` taşır: pasif (interceptor 401) yayında boş → binder
// varsayılan mesajı gösterir; PROAKTİF yayında (ör. şifre değişimi sonrası token_version bump
// → A-01) bağlam mesajı geçilir. Böylece "token geçersizleşti" tepkisi tek yerde (binder)
// merkezîdir; gerekli HER yer `forceReauth(reason)` ile aynı çıkış+yönlendirme akışını çağırır.
export type AuthEventDetail = { reason?: string }

type Listener = (detail: AuthEventDetail) => void

const listeners: Record<AuthEvent, Set<Listener>> = {
  'signed-out': new Set(),
  forbidden: new Set(),
}

export const authEvents = {
  on(event: AuthEvent, fn: Listener): () => void {
    listeners[event].add(fn)
    return () => listeners[event].delete(fn)
  },
  emit(event: AuthEvent, detail: AuthEventDetail = {}): void {
    listeners[event].forEach((fn) => fn(detail))
  },
}

// Proaktif yeniden-kimlik-doğrulama tetikleyici: oturumun geçersizleştiğini BİLDİĞİMİZ her yerde
// (şifre değişimi gibi token_version'ı bump'layan kendi-aksiyonlarımız) çağrılır → pasif 401'i
// beklemeden niyetli çıkış + bağlam mesajıyla login'e yönlendirme (binder ele alır).
export const forceReauth = (reason: string): void => {
  authEvents.emit('signed-out', { reason })
}
